import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'parse';
const parse: typeof Parse = require('parse');

declare const $: any;

@Component({
  selector: 'app-parameters-scrollspy',
  templateUrl: './parameters-scrollspy.component.html',
  styleUrls: ['./parameters-scrollspy.component.less']
})
export class ParametersScrollspyComponent implements OnInit {
  @Input() activeSection: string;
  showParameters: boolean;
  privateCompany: boolean;
  isSuperAdmin = false;

  constructor(private _route: ActivatedRoute,
    private readonly _router: Router) {
    this.privateCompany = parse.User.current().get('privateCompany');
    this.isSuperAdmin = parse.User.current().get('isSuperAdmin');
    if (this._router.url === "/parameters")
      this.showParameters = true
    else
      this.showParameters = false
  }
  ngOnInit() {
  }

  scrollTo(section: string) {
    $(`#${section} > .section-scroll-anchor`).get(0).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/element/parameters-scrollspy/parameters-scrollspy.component.ts